import { loadStripe as loadStripe } from '@stripe/stripe-js';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_fullName2ompl3bj5l3sh as get_fullName } from '../../../../crowpay-shared/com/crowpay/extensions/User.ext.shared.mjs';
import { _EmailAddress___get_raw__impl__6ose21hsaqj8b5ou10 as _EmailAddress___get_raw__impl__6ose2 } from '../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { RView1jxdnn5qf89cm as RView } from '../../../../kiteui-library/com/lightningkite/kiteui/views/RView.commonHtml.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  PaymentError3jximuuva0fyd as PaymentError,
  PaymentResult1ux92yt3kvdva as PaymentResult,
} from '../views/dialogs/SetupCustomerMethodDialog.mjs';
import { awaitukrc63zn80a8 as await_0 } from '../../../../kiteui-library/com/lightningkite/kiteui/afterTimeout.js.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function paymentSetup(_this__u8e3s4, setupToken, publicKey, user, onComplete) {
  _this__u8e3s4.rba(new (paymentSetup$1())(_this__u8e3s4));
  var outerStripe = {_v: null};
  var outerElements = {_v: null};
  var complete = {_v: false};
  var tmp = loadStripe;
  var tmp_0 = tmp(publicKey, new (paymentSetup$2())());
  var tmp_1 = tmp_0.then((stripe) => {
    outerStripe._v = stripe;
    var tmp;
    if (stripe == null) {
      return Unit_instance;
    }
    // Inline function 'kotlin.apply' call
    var this_0 = new (paymentSetup$4$elementOptions$1())();
    this_0.clientSecret = setupToken;
    var elementOptions = this_0;
    var elements = stripe.elements(elementOptions);
    outerElements._v = elements;
    // Inline function 'kotlin.apply' call
    var this_1 = new (paymentSetup$4$paymentOptions$3())();
    // Inline function 'kotlin.apply' call
    var this_2 = new (paymentSetup$4$paymentOptions$1())();
    // Inline function 'kotlin.apply' call
    var this_3 = new (paymentSetup$4$paymentOptions$2())();
    this_3.name = get_fullName(user);
    this_3.email = _EmailAddress___get_raw__impl__6ose2(user.g88_1);
    this_2.billingDetails = this_3;
    this_1.defaultValues = this_2;
    var paymentOptions = this_1;
    var tmp_0 = elements.create('payment', paymentOptions);
    var payElement = tmp_0.on('change', (event) => {
      complete._v = event.complete;
      onComplete(event.complete);
      return Unit_instance;
    });
    // Inline function 'kotlin.js.asDynamic' call
    payElement.mount('#payment-element');
    return Unit_instance;
  });
  tmp_1.catch(paymentSetup$lambda);
  return paymentSetup$slambda_0(outerStripe, outerElements, complete, setupToken);
}
var paymentSetup$1Class;
function paymentSetup$1() {
  if (paymentSetup$1Class === VOID) {
    class $ extends RView() {
      constructor($this_paymentSetup) {
        super($this_paymentSetup.pc());
        this.tb5_1.xb3_1 = 'div';
        this.tb5_1.hb4_1.v('kiteui-stack');
        this.tb5_1.xdo();
        this.tb5_1.ndp('payment-element');
      }
    }
    initMetadataForClass($);
    paymentSetup$1Class = $;
  }
  return paymentSetup$1Class;
}
var paymentSetup$2Class;
function paymentSetup$2() {
  if (paymentSetup$2Class === VOID) {
    class $ {}
    initMetadataForClass($);
    paymentSetup$2Class = $;
  }
  return paymentSetup$2Class;
}
var paymentSetup$4$elementOptions$1Class;
function paymentSetup$4$elementOptions$1() {
  if (paymentSetup$4$elementOptions$1Class === VOID) {
    class $ {}
    initMetadataForClass($);
    paymentSetup$4$elementOptions$1Class = $;
  }
  return paymentSetup$4$elementOptions$1Class;
}
var paymentSetup$4$paymentOptions$1Class;
function paymentSetup$4$paymentOptions$1() {
  if (paymentSetup$4$paymentOptions$1Class === VOID) {
    class $ {}
    initMetadataForClass($);
    paymentSetup$4$paymentOptions$1Class = $;
  }
  return paymentSetup$4$paymentOptions$1Class;
}
var paymentSetup$4$paymentOptions$2Class;
function paymentSetup$4$paymentOptions$2() {
  if (paymentSetup$4$paymentOptions$2Class === VOID) {
    class $ {}
    initMetadataForClass($);
    paymentSetup$4$paymentOptions$2Class = $;
  }
  return paymentSetup$4$paymentOptions$2Class;
}
var paymentSetup$4$paymentOptions$3Class;
function paymentSetup$4$paymentOptions$3() {
  if (paymentSetup$4$paymentOptions$3Class === VOID) {
    class $ {}
    initMetadataForClass($);
    paymentSetup$4$paymentOptions$3Class = $;
  }
  return paymentSetup$4$paymentOptions$3Class;
}
function paymentSetup$lambda(it) {
  return Unit_instance;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp0_elvis_lhs = $this.zjs_1._v;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return new (PaymentResult())(null, new (PaymentError())(null, null, 'An unknown error occurred.'));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var s = tmp;
  var tmp1_elvis_lhs = $this.ajt_1._v;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return new (PaymentResult())(null, new (PaymentError())(null, null, 'An unknown error occurred.'));
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var e = tmp_0;
  if (!$this.bjt_1._v) {
    return new (PaymentResult())(null, new (PaymentError())(null, null, 'An unknown error occurred.'));
  }
  var tmp_1 = await_0(e.submit(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var error = tmp_1;
  if (!(error.error == null)) {
    var tmp2_safe_receiver = error.error;
    var tmp_2 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.type;
    var tmp3_safe_receiver = error.error;
    var tmp_3 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.code;
    var tmp4_safe_receiver = error.error;
    return new (PaymentResult())(null, new (PaymentError())(tmp_2, tmp_3, tmp4_safe_receiver == null ? null : tmp4_safe_receiver.message));
  }
  var tmp_4;
  try {
    println('Making Confirm Call');
    // Inline function 'kotlin.apply' call
    var this_0 = new (paymentSetup$8$result$2())();
    this_0.elements = e;
    this_0.clientSecret = $this.cjt_1;
    // Inline function 'kotlin.apply' call
    var this_1 = new (paymentSetup$8$result$1())();
    this_1.return_url = '';
    this_0.confirmParams = this_1;
    this_0.redirect = 'if_required';
    var tmp_5 = await_0(s.confirmSetup(this_0), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var result = tmp_5;
    println('Received Confirm Call');
    var tmp5_safe_receiver = result.setupIntent;
    var tmp_6 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.payment_method;
    var tmp6_safe_receiver = result.error;
    var tmp_7;
    if (tmp6_safe_receiver == null) {
      tmp_7 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_7 = new (PaymentError())(tmp6_safe_receiver.type, tmp6_safe_receiver.code, tmp6_safe_receiver.message);
    }
    tmp_4 = new (PaymentResult())(tmp_6, tmp_7);
  } catch ($p) {
    var tmp_8;
    if ($p instanceof Exception()) {
      var e_0 = $p;
      println('Caught Confirm Exception');
      tmp_8 = new (PaymentResult())(null, new (PaymentError())(null, null, e_0.message));
    } else {
      throw $p;
    }
    tmp_4 = tmp_8;
  }
  return tmp_4;
}
var paymentSetup$8$result$1Class;
function paymentSetup$8$result$1() {
  if (paymentSetup$8$result$1Class === VOID) {
    class $ {}
    initMetadataForClass($);
    paymentSetup$8$result$1Class = $;
  }
  return paymentSetup$8$result$1Class;
}
var paymentSetup$8$result$2Class;
function paymentSetup$8$result$2() {
  if (paymentSetup$8$result$2Class === VOID) {
    class $ {}
    initMetadataForClass($);
    paymentSetup$8$result$2Class = $;
  }
  return paymentSetup$8$result$2Class;
}
var paymentSetup$slambdaClass;
function paymentSetup$slambda() {
  if (paymentSetup$slambdaClass === VOID) {
    class $ {
      constructor($outerStripe, $outerElements, $complete, $setupToken) {
        this.zjs_1 = $outerStripe;
        this.ajt_1 = $outerElements;
        this.bjt_1 = $complete;
        this.cjt_1 = $setupToken;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    paymentSetup$slambdaClass = $;
  }
  return paymentSetup$slambdaClass;
}
function paymentSetup$slambda_0($outerStripe, $outerElements, $complete, $setupToken) {
  var i = new (paymentSetup$slambda())($outerStripe, $outerElements, $complete, $setupToken);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  paymentSetup as paymentSetupaftd7izh36vp,
};
//endregion

//# sourceMappingURL=paymentActuals.js.mjs.map
